import i18n from "i18next";
import k from "src/i18n/keys";

export const getErrorMessage = (error: string) => {
  let messageToBeDisplayed = i18n.t(k._4);
  let infoText = i18n.t(k._4);
  let isEmailOrWrongPassword = false;
  switch (error) {
    case "Missing or insufficient permissions.":
      messageToBeDisplayed = i18n.t(k.THIS_EMAIL_ADDRESS_IS_NOT_VERI);
      infoText = i18n.t(k.PLEASE_CHECK_YOUR_INBOX);
      isEmailOrWrongPassword = false;
      break;
    case "Incorrect Username/Password":
      messageToBeDisplayed = i18n.t(k.THE_USERNAME_OR_PASSWORD_IS_IN);
      isEmailOrWrongPassword = true;
      break;
    case "Too many failed login attempts, try again later":
      messageToBeDisplayed = i18n.t(k.TOO_MANY_FAILED_LOGIN_ATTEMPTS);
      isEmailOrWrongPassword = true;
      break;
    default:
      messageToBeDisplayed = i18n.t(k.SOMETHING_WENT_WRONG_TRY_AGAI);
      isEmailOrWrongPassword = true;
      break;
  }
  return { messageToBeDisplayed, infoText, isEmailOrWrongPassword };
};
